<template>
  <section v-if="meta" class="meta" :aria-label="$t('clan.meta.titulo')">
    <p class="meta__rotulo">
      {{ $t('clan.meta.titulo') }}
      <span v-if="meta.alcancada" class="meta__selo">{{ $t('clan.meta.batida') }}</span>
    </p>

    <!--
      A barra é o componente inteiro. A meta é cooperativa (D22, proposta 2): a
      graça é ver o coletivo andar, e um número sozinho não mostra movimento.
    -->
    <div class="meta__barra">
      <div class="meta__barra-cheia" :style="{ width: `${percentual}%` }" />
    </div>

    <p class="meta__numeros t-numero">
      {{ formato(meta.progresso) }} / {{ formato(meta.alvo) }} kg
    </p>

    <!--
      A explicação some depois que a barra enche: enquanto ela anda, dizer que
      TODO MUNDO contribui só de jogar é o que faz o membro entender que ele já
      está ajudando sem precisar fazer nada diferente (D0).
    -->
    <p v-if="!meta.alcancada" class="meta__explicacao">{{ $t('clan.meta.explicacao') }}</p>
    <p v-else class="meta__explicacao">{{ $t('clan.meta.recompensa') }}</p>
  </section>
</template>

<script>
import * as v2 from '@/core/services/api/v2';

/**
 * A META DA SEMANA (D22, proposta 2) — "a versão calma da guerra".
 *
 * Todo mundo contribui só de jogar, ninguém perde nada, e a barra enche ou não
 * enche. É o que dá razão para voltar amanhã **sem** violar o D0: não há prazo
 * apertado, não há derrota, não há punição por não bater.
 *
 * O componente some inteiro quando não há meta (sem clã, ou erro): meia barra
 * sem número é pior que barra nenhuma.
 */
export default {
  name: 'ClanMetaDaSemana',
  emits: ['erro'],
  data() {
    return { meta: null };
  },
  computed: {
    percentual() {
      if (!this.meta?.alvo) return 0;
      // Trava em 100: o progresso passa do alvo quando o clã continua pescando
      // depois de bater, e uma barra de 140% não significa nada na tela.
      return Math.min(100, Math.round((this.meta.progresso / this.meta.alvo) * 100));
    },
  },
  created() {
    void this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.meta = await v2.metaDaSemana(this.$store.state.player.id);
      } catch (error) {
        if (error?.response?.status !== 404) this.$emit('erro', error);
      }
    },
    formato(valor) {
      return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(valor || 0);
    },
  },
};
</script>

<style scoped>
.meta {
  display: flex;
  flex-direction: column;
  gap: var(--e-1);
}

.meta__rotulo {
  display: flex;
  align-items: baseline;
  gap: var(--e-2);
  margin: 0;
  font-family: var(--fonte-display);
  font-size: var(--f-2);
  color: var(--tinta-fraca);
}

.meta__selo {
  font-size: var(--f-1);
  color: var(--latao);
}

/* A barra é papel: sulco escavado e tinta por cima, sem gradiente nem brilho. */
.meta__barra {
  height: 14px;
  background: var(--papel-sombra);
  border: 2px solid var(--madeira);
  overflow: hidden;
}

.meta__barra-cheia {
  height: 100%;
  background: var(--latao);
  transition: width 0.4s ease-out;
}

.meta__numeros {
  margin: 0;
  font-size: var(--f-2);
  color: var(--tinta);
}

.meta__explicacao {
  margin: 0;
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}
</style>
